import React, { useState, useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { motion, AnimatePresence } from 'framer-motion';
import ArrowUpIcon from '../svg/ArrowUpIcon';

const ScrollToTop = inject('studioStore')(observer(({ studioStore }) => {
  const [isVisible, setIsVisible] = useState(false);
  const primaryColor = studioStore?.colors?.primary_color;

  const toggleVisibility = () => {
    if (window.scrollY > window.innerHeight) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.2 }}
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 p-3 rounded-full shadow-lg hover:shadow-xl z-[40]"
          style={{ backgroundColor: primaryColor }}
          aria-label="Scroll to top"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <motion.div
            initial={{ y: 2 }}
            animate={{ y: -2 }}
            transition={{
              duration: 1,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut",
            }}
          >
            <ArrowUpIcon width="24px" stroke="white" />
          </motion.div>
        </motion.button>
      )}
    </AnimatePresence>
  );
}));

export default ScrollToTop;